import fa_lei from "./fa_lei.json";
import fa_bir from "./fa_bir.json";

const ctmeta = {
  fa_lei,
  fa_bir,
};

export function getContentTypeData() {
  return ctmeta[`${CONFIG.league}_${CONFIG.tricode}`];
}
